import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/case-studies/skincare-routine-mobile-app/page.tsx");
